import {
  FileText,
  Home,
  LayoutDashboard,
  Store,
  Users,
  Wallet,
  type LucideIcon,
} from "lucide-react";
import { useTranslation } from "react-i18next";
import { Tabs } from "@/components/ui";

export type AdminUserDetailTabId =
  | "overview"
  | "structures"
  | "activities"
  | "associations"
  | "legal"
  | "transactions";

const TAB_ICONS: Record<AdminUserDetailTabId, LucideIcon> = {
  overview: LayoutDashboard,
  structures: Home,
  activities: Store,
  associations: Users,
  legal: FileText,
  transactions: Wallet,
};

interface AdminUserDetailTabNavProps {
  /** Tabs to render, in display order (only the ones the page can show). */
  tabs: readonly AdminUserDetailTabId[];
  activeTab: AdminUserDetailTabId;
  onTabChange: (tab: AdminUserDetailTabId) => void;
}

export function AdminUserDetailTabNav({
  tabs,
  activeTab,
  onTabChange,
}: AdminUserDetailTabNavProps) {
  const { t } = useTranslation("adminUsers");

  return (
    <Tabs
      variant="underline"
      idPrefix="admin-user"
      ariaLabel={t("detail.tabs.ariaLabel")}
      activeTab={activeTab}
      onTabChange={onTabChange}
      className="mb-5"
      tabs={tabs.map((id) => {
        const Icon = TAB_ICONS[id];
        return {
          id,
          label: t(`detail.tabs.${id}`),
          icon: <Icon className="h-4 w-4" />,
        };
      })}
    />
  );
}
